import { createContext } from 'react'

export const Firm = createContext({
  subdomain: null,
})
